<div class="gcontainer bwhite">
  <div class="row breadcrumb-header align-items-center sticky-header">
    <div class="col-md-4">
      <nav aria-label="breadcrumb" class="mt-8">
        <ol class="breadcrumb">
          <li
            class="breadcrumb-item active breadcrumb cursor"
            aria-current="page"
            (click)="reDirectUrl()"
            tabindex="0">
            Dashboard
          </li>
          @if (worksheetRecords) {
            <li class="breadcrumb-item active" aria-current="page">
              {{ worksheetRecords.company.name }} -  {{ worksheetRecords.project.projectName }}
            </li>
          }
          </ol>
        </nav>
      </div>
      <div class="col-md-8 d-flex justify-content-end align-items-center gap-2">
        <button
          mat-raised-button
          (click)="printTargetWeights()">
          Print Target Weights
        </button>
        <!-- SAVE -->
        <button
          mat-raised-button
          color="primary"
          (click)="saveTable()">
          Save Table
        </button>
        <!-- ACTIONS -->
        <button
          mat-raised-button
          color="primary"
          [matMenuTriggerFor]="headerMenu">
          ACTIONS
        </button>
        <mat-menu #headerMenu="matMenu">
          <button mat-menu-item (click)="viewSubmissionForm()">
            <mat-icon>visibility</mat-icon>
            <span>View Submission Form</span>
          </button>
        </mat-menu>
      </div>
    </div>

    <!-- HEADER CARD -->
    <mat-card class="bsmokewhite">
      <mat-card-content>
        <div class="row">
          <div class="col-md-1 worksheet-header-column-first">
            <h1 class="mat-h1">Native Soil</h1>
            <p>Single Proctor</p>
          </div>
          <div class="col-md-1 worksheet-header-column-middle">
            <div class="pr-32">
              @if (worksheetRecords) {
                <span
                  class="mat-header-data"
                  >
                  {{ worksheetRecords.project.referenceId }}
                </span>
              }
            </div>
            <mat-label class="mat-header-subtitle">Reference</mat-label>
          </div>
          <div class="col-md-2 worksheet-header-column-middle">
            <div class="pr-32">
              @if (worksheetRecords) {
                <span
                  class="mat-header-data word-break-anyware"
                  >
                  {{ worksheetRecords.company.name || '-'}}
                </span>
              }
            </div>
            <mat-label class="mat-header-subtitle">Customer</mat-label>
          </div>
          <div class="col-md-2 worksheet-header-column-middle">
            <div class="pr-32">
              @if (worksheetRecords) {
                <span
                  class="mat-header-data word-break-anyware"
                  >
                  {{ worksheetRecords.project.projectName }}
                </span>
              }
            </div>
            <mat-label class="mat-header-subtitle">Project Name</mat-label>
          </div>
          <div class="col-md-1 worksheet-header-column-middle">
            <div class="pr-32">
              @if (worksheetRecords) {
                <span
                  class="mat-header-data word-break-anyware"
                  >
                  {{ worksheetRecords.project.projectNumber || '-'}}
                </span>
              }
            </div>
            <mat-label class="mat-header-subtitle">Project Number</mat-label>
          </div>
          <div class="col-md-1 worksheet-header-column-middle">
            <div class="pr-32">
              @if (worksheetRecords) {
                <span
                  class="mat-header-data"
                  >
                  {{ worksheetRecords.project.storageCompartment || '-' }}
                </span>
              }
            </div>
            <mat-label class="mat-header-subtitle">Storage Location</mat-label>
          </div>
          <div class="col-md-1 worksheet-header-column-middle">
            <div class="pr-32">
              @if (worksheetRecords) {
                <span
                  class="mat-header-data"
                  >
                  {{ worksheetRecords.project.sampleReceivedDate
                  ? (worksheetRecords.project.sampleReceivedDate | utcToLocal:'date')
                  : '-' }}
                </span>
              }
            </div>
            <mat-label class="mat-header-subtitle">Samples Received</mat-label>
          </div>
          <div class="col-md-1 worksheet-header-column-middle">
            <div class="pr-32">
              @if (worksheetRecords) {
                <span
                  class="mat-header-data"
                  >
                  {{ worksheetRecords.project.instructionsConfirmedAt
                  ? (worksheetRecords.project.instructionsConfirmedAt | utcToLocal:'date')
                  : '-' }}
                </span>
              }
            </div>
            <mat-label class="mat-header-subtitle">Instructions Confirmed</mat-label>
          </div>
          <div class="col-md-1 worksheet-header-column-last">
            <div class="pr-32">
              @if (worksheetRecords) {
                <span
                  class="mat-header-data"
                  >
                  {{ worksheetRecords.project.dueDate
                  ? (worksheetRecords.project.dueDate | utcToLocal:'date')
                  : '-' }}
                </span>
              }
            </div>
            <mat-label class="mat-header-subtitle">Due Date</mat-label>
          </div>
          <div class="col-md-1 d-flex justify-content-end">
            <div class="days-badge" [ngClass]="{'danger': (daysLeft) < 10,'normal': (daysLeft) >= 10}">
              <span class="days-value">
                {{ daysLeft }}
              </span>
              <span class="days-label">Days</span>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <div class="row middle-header">
      <!-- Notes section -->
      <div class="col-md-11 d-flex justify-content-start flex-wrap gap-3">
        <div>
          <div class="row">
            @if (note) {
              <div>
                <mat-label class="mat-subtitle-2 bold-title">
                  @if (note.updatedBy) {
                    <span class="d-inline">
                      {{ note.updatedBy.firstName }} {{ note.updatedBy.lastName }}:
                    </span>
                  }
                  @if (note.createdAt) {
                    <span class="d-inline">
                      {{ note.createdAt | utcToLocal: 'date' }}
                      {{ note.createdAt | utcToLocal: 'time' }}
                    </span>
                  }
                </mat-label>
              </div>
            }

            @if (!note) {
              <div style="min-height: 60px">
                <p class="note-text truncate-label">No Notes Available.</p>
              </div>
            }
          </div>
          <div class="row">
            @if (note) {
              <span
                class="note-text mat-subtitle-2"
                matTooltipClass="my-custom-tooltip"
                #tooltip="matTooltip"
                [matTooltip]="note.text">
                {{ noteText }}
              </span>
            }
          </div>
          <div class="row">
            <div class="d-flex justify-content-start flex-wrap gap-3">
              <a class="link-text-data" (click)="openViewNotesDialog()" href="javascript:void(0);">
                <img src="../../../../assets/icons/New Window.svg" />
                All Notes
              </a>
              <a class="link-text-data" (click)="openViewInstructionsDialog()" href="javascript:void(0);">
                <img src="../../../../assets/icons/New Window.svg" />
                Instructions
              </a>
              <app-customer-attachments
                class="worksheet-attachements"
                [projectId]="projectId"
                [backgroundClass]="'gray'"
                [showSuccess]="false">
              </app-customer-attachments>
            </div>
          </div>
          <div class="row">
            <div class="d-flex justify-content-start flex-wrap gap-3">
              <a class="link-text-data" (click)="asReceivedWorksheet()" href="javascript:void(0);">
                <img src="../../../../assets/icons/New Window.svg" />As-Received
              </a>

              <a class="link-text-data" (click)="moistureConditioningWorksheet()" href="javascript:void(0);">
                <img src="../../../../assets/icons/New Window.svg" />Moisture
              </a>

              <a class="link-text-data disabled-link" (click)="singleProctorWorksheet()" href="javascript:void(0);">
                <img src="../../../../assets/icons/New Window.svg" />Proctor
              </a>

              <a class="link-text-data" (click)="compactionWorksheet()" href="javascript:void(0);">
                <img src="../../../../assets/icons/New Window.svg" />Compaction
              </a>

              <a class="link-text-data" (click)="thermalResistivityWorksheet()" href="javascript:void(0);">
                <img src="../../../../assets/icons/New Window.svg" />TR
              </a>
            </div>
          </div>
        </div>
        <!-- OVEN DATE, Wet Test Data, Dry Test Data section -->
        <div>
          <div class="test-data-text d-flex align-items-center gap-2">
            <div class="edit-icon-wrapper clickable-row"
              (click)="openProjectDetailsComponent('Oven Date', 'ovenDate')">

              <img
                class="edit-icon"
                src="../../../../assets/icons/Edit.svg" />

                <span class="link-text-custom">
                  Oven Date {{ worksheetRecords?.project?.ovenDate ? ': ' + worksheetRecords?.project?.ovenDate : '' }}
                </span>
              </div>
            </div>

            <div class="test-data-text d-flex align-items-center gap-2">
              <div class="edit-icon-wrapper clickable-row"
                (click)="openProjectDetailsComponent('Wet Test Data', 'wetTestData')">

                <img
                  class="edit-icon"
                  src="../../../../assets/icons/Edit.svg" />

                  <span class="link-text-custom">
                    Wet Test Data {{ worksheetRecords?.project?.wetTestData ? ': ' + worksheetRecords?.project?.wetTestData : '' }}
                  </span>
                </div>
              </div>

              <div class="test-data-text d-flex align-items-center gap-2">
                <div class="edit-icon-wrapper clickable-row"
                  (click)="openProjectDetailsComponent('Dry Test Data', 'dryTestData')">

                  <img
                    class="edit-icon"
                    src="../../../../assets/icons/Edit.svg" />

                    <span class="link-text-custom">
                      Dry Test Data {{ worksheetRecords?.project?.dryTestData ? ': ' + worksheetRecords?.project?.dryTestData : '' }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-1 d-flex flex-column align-items-end gap-1">
              @if (worksheetRecords?.project?.geothermField) {
                <mat-chip class="chipset-green">
                  <span class="text-white chip-text">Geotherm Field Test</span>
                </mat-chip>
              }

              @if (worksheetRecords?.project?.rushTesting) {
                <mat-chip class="chipset-warning">
                  <img src="./../../../assets/icons/rush-warning-icon.svg" class="icon-position" />
                  <span class="chip-text">Rush</span>
                </mat-chip>
              }
            </div>
          </div>

          <!-- MAT TABLE -->
          @if (isInstructionsConfirmed) {
            <div class="row mt-3">
              <div class="col-12">
                <table mat-table [dataSource]="dataSource" class="material-table custom-table">
                  <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef>
                      <mat-checkbox
                        (click)="$event.stopPropagation()"
                        (change)="masterToggle()"
                        [checked]="isAllSelected()"
                        [indeterminate]="isIndeterminate()"
                        tabindex="-1">
                      </mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let row"
                      (click)="$event.stopPropagation()">
                      <mat-checkbox
                        (click)="$event.stopPropagation()"
                        (change)="toggleSelection(row)"
                        [checked]="selection.isSelected(row)"
                        tabindex="-1">
                      </mat-checkbox>
                    </td>
                  </ng-container>
                  <!-- Sample ID Column -->
                  <ng-container matColumnDef="sampleId">
                    <th mat-header-cell *matHeaderCellDef>Sample Id</th>
                    <td mat-cell *matCellDef="let element">{{ element.sampleId }}</td>
                  </ng-container>
                  <!-- Depth Column -->
                  <ng-container matColumnDef="depth">
                    <th mat-header-cell *matHeaderCellDef>Depth (ft)</th>
                    <td mat-cell *matCellDef="let element">{{ element.displayDepth }}</td>
                  </ng-container>
                  <!-- Bulk Density Column -->
                  <ng-container matColumnDef="bulkDensity">
                    <th mat-header-cell *matHeaderCellDef>Bulk Density (pcf)</th>
                    <td mat-cell *matCellDef="let element">{{ element.bulkDensity | number:'1.1-1' }}</td>
                  </ng-container>
                  <!-- Dry Density Column -->
                  <ng-container matColumnDef="dryDensity">
                    <th mat-header-cell *matHeaderCellDef>Dry Density (pcf)</th>
                    <td mat-cell *matCellDef="let element">{{ element.dryDensity }}</td>
                  </ng-container>
                  <!-- Proctor Mould Weight Column -->
                  <ng-container matColumnDef="proctorMouldWeight">
                    <th mat-header-cell *matHeaderCellDef>Proctor Mould Weight (gm)</th>
                    <td mat-cell *matCellDef="let element" class="cell-stack">
                      <input
                        type="number"
                        matInput [(ngModel)]="element.proctorMouldWeight" class="table-input"
                        (ngModelChange)="updateCalculations(element)"
                        (focus)="onFocusClearZero(element, 'proctorMouldWeight')"
                        (blur)="onBlurRestoreZero(element, 'proctorMouldWeight')"
                        [attr.data-row-id]="element.id"
                        [attr.data-type]="'proctorMouldWeight'"
                        (keydown.enter)="focusNextRow($event, element.id, 'proctorMouldWeight')"
                        (wheel)="preventNumberInputChange($event)"
                        (keydown.arrowup)="$event.preventDefault()"
                        (keydown.arrowdown)="$event.preventDefault()"
                        />
                      </td>
                    </ng-container>
                    <!-- Mould And Soil Weight Column -->
                    <ng-container matColumnDef="mouldAndSoilWeight">
                      <th mat-header-cell *matHeaderCellDef>Mould And Soil Weight (gm)</th>
                      <td mat-cell *matCellDef="let element">
                        <input
                          type="number"
                          matInput
                          [(ngModel)]="element.mouldAndSoilWeight"
                          class="table-input"
                          (ngModelChange)="updateCalculations(element)"
                          (focus)="onFocusClearZero(element, 'mouldAndSoilWeight')"
                          (blur)="onBlurRestoreZero(element, 'mouldAndSoilWeight')"
                          (keydown.enter)="focusNextRow($event, element.id, 'mouldAndSoilWeight')"
                          [attr.data-row-id]="element.id"
                          [attr.data-type]="'mouldAndSoilWeight'"
                          (wheel)="preventNumberInputChange($event)"
                          (keydown.arrowup)="$event.preventDefault()"
                          (keydown.arrowdown)="$event.preventDefault()"
                          />
                        </td>
                      </ng-container>
                      <!-- Net Weight of Soil Column -->
                      <ng-container matColumnDef="soilNetWeight">
                        <th mat-header-cell *matHeaderCellDef>Net Soil Weight (gm)</th>
                        <td mat-cell *matCellDef="let element">{{ element.soilNetWeight }}</td>
                      </ng-container>
                      <!-- Proctor Mold Diameter Column -->
                      <ng-container matColumnDef="proctorMoldDiameter">
                        <th mat-header-cell *matHeaderCellDef>Proctor Mold Diameter (inches)</th>
                        <td mat-cell *matCellDef="let element">
                          <mat-button-toggle-group
                            class="small-toggle"
                            [(ngModel)]="element.proctorMoldDiameter"
                            (ngModelChange)="updateCalculations(element)">
                            <mat-button-toggle [value]="4" tabindex="-1">4</mat-button-toggle>
                            <mat-button-toggle [value]="6" tabindex="-1">6</mat-button-toggle>
                          </mat-button-toggle-group>
                        </td>
                      </ng-container>
                      <!-- Grams per Cubic Centimeter Column -->
                      <ng-container matColumnDef="gramPerCmCube">
                        <th mat-header-cell *matHeaderCellDef>g/cm³</th>
                        <td mat-cell *matCellDef="let element">{{ element.gramPerCmCube | number:'1.1-1' }}</td>
                      </ng-container>
                      <!-- Assigned To Column -->
                      <ng-container matColumnDef="assignedTo">
                        <th mat-header-cell *matHeaderCellDef>Assigned To</th>
                        <td mat-cell *matCellDef="let element" class="text-center">
                          {{ element.assignedTo ?? '' }}
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef>Status</th>
                        <td mat-cell *matCellDef="let element">
                          @if (calculateRowStatus(element)) {
                            <img
                              src="../../../../assets/icons/Check.svg" />
                          }
                          @if (!calculateRowStatus(element)) {
                            <img
                              src="../../../../assets/icons/table icon.svg" />
                          }
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element">
                          <button mat-icon-button [matMenuTriggerFor]="menu" tabindex="-1">
                            <mat-icon>more_vert</mat-icon>
                          </button>
                          <mat-menu #menu="matMenu">
                            <button mat-menu-item (click)="openAssignToDialog(element)">
                              <span class="menu-text">
                                <img src="/assets/icons/User-multiple.svg" alt="Assign" />
                                &nbsp; Assign To
                              </span>
                            </button>
                          </mat-menu>
                        </td>
                      </ng-container>
                      <!-- Header Row -->
                      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                      <!-- Data Row -->
                      <tr mat-row [class.bold-bottom-border]="isLastRowOfSample(row, i)" *matRowDef="let row; let i = index; columns: displayedColumns;"></tr>
                    </table>
                  </div>
                </div>
              }
              @if (isInstructionsConfirmed === false) {
                <div class="warning-container">
                  <div class="warning">
                    <mat-icon>warning</mat-icon>
                    <span>Instructions are not confirmed.</span>
                  </div>
                </div>
              }
            </div>